"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20PreloadScene = void 0;
const Game_1 = require("./Game");
const KHPreloadScene_1 = require("./KH/KHPreloadScene");
const IGO50GameListScene_1 = require("./IGO50GameListScene");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHAudioScene_1 = require("./KH/KHAudioScene");
const Z20AudioScene_1 = require("./Z20AudioScene");
const Z20SceneNames_1 = require("./Z20SceneNames");
class Z20PreloadScene extends KHPreloadScene_1.KHPreloadScene {
    constructor() {
        super(Z20SceneNames_1.default.Preload);
    }
    nextScene() {
        // return Z20SceneNames.Menu;
        return Z20SceneNames_1.default.Cutscene;
        // return Z20SceneNames.SeedPicker;
    }
    palette() {
        // BG, Load Bar, Logo
        return [0x0, 0xffffff, 0xd10c4c];
    }
    preloadFinished() {
        Game_1.gameManager.addOrGetAudioScene(this);
        for (let i = 1; i <= Game_1.game.npcCount; i++) {
            this.anims.create({
                key: `npc${i}-idle`,
                frames: this.anims.generateFrameNumbers(`npc${i}`),
                frameRate: 1
            });
        }
    }
    loadAssets() {
        super.loadAssets();
        const frameSize = { frameWidth: 16, frameHeight: 16 };
        for (let i = 1; i <= Game_1.game.npcCount; i++) {
            this.load.spritesheet(`npc${i}`, `assets/npc${i}-sheet.png`, frameSize);
        }
        this.load.spritesheet('tree', 'assets/tree.png', frameSize);
        for (let i = 1; i <= Game_1.game.toolCount; i++) {
            this.load.image(`tool${i}`, `assets/tool${i}.png`);
        }
        for (let i = 0; i < Game_1.game.grassCount; i++) {
            this.load.spritesheet(`grass${i}`, `assets/grass${i}.png`, frameSize);
        }
        this.load.spritesheet('intro_1', 'assets/intro_1.png', { frameWidth: 192, frameHeight: 128 });
        this.load.image('trophy', 'assets/trophy.png');
        this.load.image('text_beat', 'assets/text_beat.png');
        this.load.image('text_give', 'assets/text_give.png');
        this.load.image('text_youare', 'assets/text_youare.png');
        this.load.image('text_youhave', 'assets/text_youhave.png');
        this.load.image('text_winis', 'assets/text_winis.png');
        this.load.image('arrow_up', 'assets/arrow_up.png');
        this.load.bitmapFont('legacys', 'assets/legacys_0.png', 'assets/legacys.fnt');
        this.load.bitmapFont('igo50', 'assets/IGO50_0.png', 'assets/IGO50.fnt');
        this.load.image('border', 'assets/border.png');
        // this.load.image('logo', 'assets/logo_small.png');
        this.load.image('logo_top', 'assets/logo_top.png');
        this.load.image('logo_norm', 'assets/logo_normal.png');
        this.load.image('logo_gold', 'assets/logo_gold.png');
        this.load.image('logo_chry', 'assets/logo_cherry.png');
        this.load.image('cutscene_end', 'assets/end_screen.png');
        KHAudioScene_1.KHAudioScene.registerClips(this, Z20AudioScene_1.Z20AudioScene.sfxClips());
        // OUTER CONTEXT
        IGO50GameListScene_1.IGO50GameListScene.loadAll(this);
        // END OUTER CONTEXT
        this.scene.run(KHInputScene_1.KHInputScene.NAME);
    }
}
exports.Z20PreloadScene = Z20PreloadScene;
